import React from 'react';
import { translate } from 'react-i18next';
import {Card, CardText} from 'material-ui/Card';
import ProductNew from './ProductNew';
import ProductCreate from './ProductCreate';
import ProductCopyTemplate from './ProductCopyTemplate';
import {List, ListItem} from 'material-ui/List';
import FlatButton from 'material-ui/FlatButton';
import firebase from '../firebase';
import compose from '../compose';
import user from '../Auth/user';
import {Toolbar, ToolbarGroup, ToolbarTitle} from 'material-ui/Toolbar';
import { Link } from 'react-router-dom';
import Checkbox from 'material-ui/Checkbox';
import createHistory from 'history/createBrowserHistory';
import IconButton from 'material-ui/IconButton';
import ArrowBack from 'material-ui/svg-icons/navigation/arrow-back';
import LoadingIndicator from '../Navigation/LoadingIndicator';
import ProductAvatar from './ProductAvatar';
import Previous from 'material-ui/svg-icons/navigation/chevron-left';
import Next from 'material-ui/svg-icons/navigation/chevron-right';
import FirstPage from 'material-ui/svg-icons/navigation/first-page';
import LastPage from 'material-ui/svg-icons/navigation/last-page';

class ProductList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      products: [],
      dialogOpen: false,
      dialogCreateOpen: false,
      dialogCopyTemplateOpen: false,
      selectedProducts: [],
      loadingIndicator: 'flex',
      productsPerPage: 15,
      firstPage: true,
      lastPage: false
    };
  }
  componentDidMount = () => {
    const {user} = this.props;

    if(user.shopkeeperId) {
      this.getFirstProducts(user.shopkeeperId);
    }
  }

  componentWillReceiveProps = (nextProps) => {
    const {selectedProducts} = nextProps || this.props;
    if (!selectedProducts) return;
    if(selectedProducts.length !== this.state.selectedProducts.length) {
      this.setState({selectedProducts});
    }
  }

  getFirstProducts = (shopkeeperId) => {
    const {firebase} = this.props;

    firebase.database().ref('shopkeepers/' + shopkeeperId + '/products/')
      .orderByChild('name')
      .limitToFirst(this.state.productsPerPage)
      .once('value', (queryProducts) => {
        this.updateFirstProducts(queryProducts);
        this.setState({loadingIndicator: 'none'});
      });
  }
  getLastProducts = () => {
    const {firebase} = this.props;

    firebase.database().ref('shopkeepers/' + this.props.user.shopkeeperId + '/products/')
      .orderByChild('name')
      .limitToLast(this.state.productsPerPage)
      .once('value', (queryProducts) => {
        this.updateProducts(queryProducts);
      });
    this.setState({lastPage: true, firstPage: false});
  }
  getNextProducts = () => {
    const {firebase} = this.props;

    firebase.database().ref('shopkeepers/' + this.props.user.shopkeeperId + '/products/')
      .orderByChild('name')
      .limitToFirst(this.state.productsPerPage)
      .startAt(this.state.products[this.state.products.length - 1].name + 'a')
      .once('value', (queryProducts) => {
        this.updateProducts(queryProducts);
      });
    this.setState({firstPage: false});
  }
  getPreviousProducts = () => {
    const {firebase} = this.props;

    firebase.database().ref('shopkeepers/' + this.props.user.shopkeeperId + '/products/')
      .orderByChild('name')
      .limitToLast(this.state.productsPerPage)
      .endAt(this.state.products[0].name.slice(0, -1))
      .once('value', (queryProducts) => {
        this.updateProducts(queryProducts);
      });
    this.setState({lastPage: false});
  }

  updateFirstProducts = (queryProducts) => {
    const {firebase} = this.props;

    const products = [];
    queryProducts.forEach((data) => {
      const product = {
        key: data.key,
        ...data.val()
      };
      products.push(product);
    });
    if (products.length > 0) {
      this.setState({products, firstProduct: products[0].key, firstPage: true});
    } else {
      this.setState({firstPage: true, lastPage: true});
      return;
    }

    firebase.database().ref('shopkeepers/' + this.props.user.shopkeeperId + '/products/')
      .orderByChild('name')
      .limitToLast(1)
      .once('value', (product) => {
        product.forEach((lastProduct) => {
          if (products[products.length - 1].key === lastProduct.key) {
            this.setState({lastPage: true});
          } else {
            this.setState({lastPage: false});
          }
          this.setState({lastProduct: lastProduct.key});
        });
      });

    this.getPictures(products);
  }

  updateProducts = (queryProducts) => {
    const products = [];
    queryProducts.forEach((data) => {
      const product = {
        key: data.key,
        ...data.val()
      };
      products.push(product);
    });
    this.setState({products});
    if (products[0].key === this.state.firstProduct) {
      this.setState({firstPage: true});
    }
    if (products[products.length - 1].key === this.state.lastProduct) {
      this.setState({lastPage: true});
    }
    this.getPictures(products);
  }

  getPictures = (products) => {
    const {firebase} = this.props;
    products.forEach((product) => {
      if (product.picture) {
        firebase.storage().ref(product.picture).getDownloadURL().then((url) => {
          product.pictureUrl = url;
          const currentProducts = this.state.products.slice();
          this.setState({products: currentProducts});
        });
      }
    });
  }

  handleOpen = () => this.setState({dialogOpen: true});
  handleClose = () => this.setState({dialogOpen: false});

  handleCreateOpen = () => this.setState({dialogCreateOpen: true});
  handleCreateClose = () => this.setState({dialogCreateOpen: false});

  handleCopyTemplateOpen = () => this.setState({dialogCopyTemplateOpen: true});
  handleCopyTemplateClose = () => this.setState({dialogCopyTemplateOpen: false});

  render() {
    const {t} = this.props;
    const containerElement = this.props.onSelectChange ? () => 'span' : (productKey) => (<Link to={`products/${productKey}`} />);
    const checkbox = this.props.onSelectChange ? (product) => (<Checkbox
      checked={this.state.selectedProducts.some(item => item.key === product.key)}
      onCheck={(event, isInputChecked) => this.props.onSelectChange(isInputChecked, product)}
    />) : () => null;
    const leftavatar = this.props.onSelectChange ? () => null : (product) => (<ProductAvatar src={product.pictureUrl} name={product.name}/>);
    const rightavatar = this.props.onSelectChange ? (product) => (<ProductAvatar src={product.pictureUrl} name={product.name} />) : () => null;

    const toolbarGroup = this.props.onSelectChange ?
      <ToolbarGroup firstChild={true}>
        <IconButton onTouchTap={createHistory().goBack}>
          <ArrowBack color="rgba(0,0,0,0.4)" />
        </IconButton>
        <ToolbarTitle text={`${t('product.chooseFor')} ${this.props.standname}`} />
      </ToolbarGroup>
     :
      <ToolbarGroup>
        <ToolbarTitle text={t('product.products')} />
      </ToolbarGroup>
    ;

    const productCreate = this.props.onSelectChange ?
    <ProductCreate open={this.state.dialogCreateOpen} handleClose={this.handleCreateClose} addToStand={this.props.onSelectChange} />
    :
    <ProductCreate open={this.state.dialogCreateOpen} handleClose={this.handleCreateClose} />;

    const productCopyTemplate = this.props.onSelectChange ?
    <ProductCopyTemplate open={this.state.dialogCopyTemplateOpen} handleClose={this.handleCopyTemplateClose} addToStand={this.props.onSelectChange} />
    :
    <ProductCopyTemplate open={this.state.dialogCopyTemplateOpen} handleClose={this.handleCopyTemplateClose} />;

    const products = this.state.products.map((product) => (
      <ListItem key={product.key}
        primaryText={product.name}
        containerElement={containerElement(product.key)}
        leftAvatar={leftavatar(product)}
        rightAvatar={rightavatar(product)}
        leftCheckbox={checkbox(product)}
        />
    ));

    return (
        <Card className='cardStyle'>
          <Toolbar>
              {toolbarGroup}
            <ToolbarGroup lastChild={true}>
              <FlatButton label={t('product.new')} primary={true} onTouchTap={this.handleOpen} />
            </ToolbarGroup>
          </Toolbar>
          <CardText style={{textAlign: 'left', position: 'relative'}}>
            <List>
              {products}
            </List>
            <div>
              <IconButton
                onTouchTap={() => this.getFirstProducts(this.props.user.shopkeeperId)}
                disabled={(this.state.firstPage)}>
                <FirstPage />
              </IconButton>
              <IconButton
                onTouchTap={this.getPreviousProducts}
                disabled={(this.state.firstPage)}>
                <Previous />
              </IconButton>
              <IconButton
                onTouchTap={this.getNextProducts}
                disabled={(this.state.lastPage)}>
                <Next />
              </IconButton>
              <IconButton
                onTouchTap={this.getLastProducts}
                disabled={(this.state.lastPage)}>
                <LastPage />
              </IconButton>
            </div>
            <LoadingIndicator display={this.state.loadingIndicator} />
          </CardText>
          <ProductNew
            open={this.state.dialogOpen}
            handleClose={this.handleClose}
            handleCopyTemplateOpen={this.handleCopyTemplateOpen}
            handleCreateOpen={this.handleCreateOpen}>
          {productCreate}
          {productCopyTemplate}
        </ProductNew>
      </Card>
    );
  }
}

const enhance = compose(translate(), firebase, user);

export default enhance(ProductList);



// WEBPACK FOOTER //
// ./src/Product/ProductList.js